// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from '@med/app/auth/auth.component';
import { PATHS } from '@med/utils';
import { LoginGuard } from '@med/app/auth/services/login.guard';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: PATHS.Login,
        loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
        canActivate: [LoginGuard],
      },
      {
        path: PATHS.ResetPassword,
        loadChildren: () => import('./reset-password/reset-password.module').then((m) => m.ResetPasswordModule),
        canActivate: [LoginGuard],
      },
      {
        path: PATHS.ClientUserInvitation,
        loadChildren: () => import('./client-user-invitation/client-user-invitation.module').then((m) => m.ClientUserInvitationModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}
